import React from 'react'

const Kampuspedia = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.74 1.5a.745.745 0 0 0-.74.75v17.546a2.7 2.7 0 0 0 .745 1.89 2.62 2.62 0 0 0 1.842.814h14.357a2.69 2.69 0 0 0 1.917-.805 2.77 2.77 0 0 0 .794-1.945 2.77 2.77 0 0 0-.794-1.945A2.69 2.69 0 0 0 18.944 17h-.571v-.73a.745.745 0 0 0-.74-.75.745.745 0 0 0-.739.75V17H4.78a.745.745 0 0 0-.74.75c0 .414.331.75.74.75.327 0 .64.132.871.366a1.26 1.26 0 0 1 0 1.768A1.223 1.223 0 0 1 4.78 21h-.17a1.156 1.156 0 0 1-.804-.358 1.19 1.19 0 0 1-.327-.834V3h12.287a1.14 1.14 0 0 1 .81.353 1.174 1.174 0 0 1 .328.835v.552c0 .414.33.75.74.75a.745.745 0 0 0 .739-.75v-.535a2.705 2.705 0 0 0-.747-1.898 2.6 2.6 0 0 0-1.858-.807H2.739zm4.454 17a2.782 2.782 0 0 1 0 2.5h11.75c.327 0 .64-.132.872-.366a1.26 1.26 0 0 0 0-1.768 1.223 1.223 0 0 0-.872-.366H7.194z"
      fill="#000"
    />
    <path
      d="M5.036 6c0-.414.331-.75.74-.75h6.751c.409 0 .74.336.74.75s-.331.75-.74.75H5.775A.745.745 0 0 1 5.036 6zm.739 3.25a.745.745 0 0 0-.739.75c0 .414.331.75.74.75h3.863c.409 0 .74-.336.74-.75s-.331-.75-.74-.75H5.775zM5.036 14c0-.414.331-.75.74-.75h5.785c.409 0 .74.336.74.75s-.331.75-.74.75H5.775a.745.745 0 0 1-.739-.75z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.537 10.28c0-2.17 1.735-3.93 3.874-3.93 2.14 0 3.874 1.76 3.874 3.93 0 .863-.275 1.662-.74 2.31l2.24 2.28a.758.758 0 0 1-.003 1.061.732.732 0 0 1-1.045-.002l-2.274-2.315a3.815 3.815 0 0 1-2.052.596c-2.14 0-3.874-1.76-3.874-3.93zm3.874-2.43c-1.323 0-2.395 1.088-2.395 2.43s1.072 2.43 2.395 2.43 2.395-1.088 2.395-2.43-1.072-2.43-2.395-2.43z"
      fill="#000"
    />
  </svg>
)

export default Kampuspedia
